import { render } from "./AppCookieConsent.vue?vue&type=template&id=16a6704b"
import script from "./AppCookieConsent.vue?vue&type=script&lang=js"
export * from "./AppCookieConsent.vue?vue&type=script&lang=js"

import "./AppCookieConsent.vue?vue&type=style&index=0&id=16a6704b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__